module.exports = __webpack_public_path__ + "img/vicky_eqrcode.8aeb8691.png";